// src/pages/Login.jsx
import React, { useState, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

function Login() {
  const { login, loading } = useContext(AuthContext);
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [erro, setErro] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro("");

    try {
      await login(email, password);
      navigate("/dashboard");
    } catch (e) {
      console.error("Erro no login:", e?.response?.data || e);
      setErro("Email ou senha incorretos.");
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <div
        className="card p-4 shadow-lg border-0"
        style={{ maxWidth: "420px", width: "100%" }}
      >
        {/* LOGO */}
        <div className="text-center mb-3">
          <img
            src="/logo-aristo.png"
            alt="Logo"
            style={{ width: "140px", opacity: 0.95 }}
          />
        </div>

        {/* TÍTULO */}
        <h4 className="text-center fw-bold mb-2">Bem-vindo</h4>
        <p
          className="text-center text-muted mb-4"
          style={{ fontSize: "0.9rem" }}
        >
          Entre com suas credenciais para continuar
        </p>

        {/* ALERTAS */}
        {erro && <div className="alert alert-danger py-2">{erro}</div>}

        {/* FORMULÁRIO */}
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label fw-semibold">Email</label>
            <input
              type="email"
              className="form-control"
              placeholder="seuemail@dominio.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
            />
          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold">Senha</label>
            <input
              type="password"
              className="form-control"
              placeholder="Sua senha"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {/* BOTÃO */}
          <button
            className="btn btn-primary w-100 py-2 mt-2"
            type="submit"
            disabled={loading}
          >
            {loading ? "Entrando..." : "Entrar"}
          </button>
        </form>

        {/* FOOTER DO CARD */}
        <p
          className="text-center text-muted mt-4 mb-0"
          style={{ fontSize: "0.8rem" }}
        >
          © {new Date().getFullYear()} Aristo Performance – Todos os direitos
          reservados
        </p>
      </div>
    </div>
  );
}

export default Login;
